import request from "@/utils/request";

// ==================== 事件相关接口 ====================

// 获取事件列表
export function getEventList(obj) {
	return request({
		url: "/admin/prediction/getEventList",
		method: "post",
		data: obj,
	});
}

// 获取事件详情
export function getEventDetail(obj) {
	return request({
		url: "/admin/prediction/getEventDetail",
		method: "post",
		data: obj,
	});
}

// 更新审核状态
export function updateReviewStatus(obj) {
	return request({
		url: "/admin/prediction/updateReviewStatus",
		method: "post",
		data: obj,
	});
}

// 获取已发布事件列表
export function getPublishedEvents(obj) {
	return request({
		url: "/admin/prediction/getPublishedEvents",
		method: "post",
		data: obj,
	});
}

// 获取事件统计
export function getEventStatistics(obj) {
	return request({
		url: "/admin/prediction/getEventStatistics",
		method: "post",
		data: obj,
	});
}

// 获取平台列表
export function getPlatformList(obj) {
	return request({
		url: "/admin/prediction/getPlatformList",
		method: "post",
		data: obj,
	});
}

// 获取分类列表
export function getCategoryList(obj) {
	return request({
		url: "/admin/prediction/getCategoryList",
		method: "post",
		data: obj,
	});
}

// ==================== 市场相关接口 ====================

// 获取市场列表
export function getMarketList(obj) {
	return request({
		url: "/admin/prediction/getMarketList",
		method: "post",
		data: obj,
	});
}

// 获取市场详情
export function getMarketDetail(obj) {
	return request({
		url: "/admin/prediction/getMarketDetail",
		method: "post",
		data: obj,
	});
}

// 获取指定事件的市场列表
export function getMarketsByEvent(obj) {
	return request({
		url: "/admin/prediction/getMarketsByEvent",
		method: "post",
		data: obj,
	});
}

// ==================== 异动相关接口 ====================

// 获取异动列表
export function getAnomalyList(obj) {
	return request({
		url: "/admin/prediction/getAnomalyList",
		method: "post",
		data: obj,
	});
}

// 获取热门异动
export function getTopAnomalies(obj) {
	return request({
		url: "/admin/prediction/getTopAnomalies",
		method: "post",
		data: obj,
	});
}

// 获取异动统计
export function getAnomalyStatistics(obj) {
	return request({
		url: "/admin/prediction/getAnomalyStatistics",
		method: "post",
		data: obj,
	});
}
